<template>
  <tabs :options="{ useUrlFragment: false }" @clicked="tabClicked" @changed="tabChanged" class="finance-parent-tabs">
    <tab name="Payin">
      <PayinAccounts ref="payinAccountsComponent" />
    </tab>
     <!--  -->
    <tab name="Payout" v-if="isShowPayoutAccounts">
      <PayoutAccounts :payoutAccountsList.sync="payoutAccountsList" @update="updatePayoutAccounts" />
    </tab>
  </tabs>
</template>

<script>
import PayinAccounts from "@/components/FinancialManagementOld/FinancialManagement"
import PayoutAccounts from "@/components/FinancialManagementOld/PayoutAccounts"
import { request } from "@/utils/utils";

export default {
  name: "Index",
  data() {
    return {
      isShowPayoutAccounts: false,
      payoutAccountsList: []
    }
  },
  components: {
    PayinAccounts, PayoutAccounts
  },
  mounted() {
    this.fetchPayoutAccountsList()
  },
  methods: {
		fetchPayoutAccountsList() {
			let that = this
			const access_token = localStorage.getItem("Authorization")
			this.loadingFullScreen('payoutAccountsLoading', 'loading', 'fa fa-hourglass-half')
      let merchantNo = localStorage.getItem('merchantNo')
			request({
				method: "post",
				url: `api/dashboard/transfer/payout-accounts-balance-list?access_token=${access_token}&merchantNo=${merchantNo}`,
				headers: {
					"Content-Type": "application/json"
				}
			}).then(res => {
				that.payoutAccountsLoading.close()
        const { code, data } = res.data
				if (code === "10000" && data) {
          that.isShowPayoutAccounts = true
          that.payoutAccountsList = data
				} else {
          that.isShowPayoutAccounts = false
          that.payoutAccountsList = []
				}
			}).catch(err => { that.payoutAccountsLoading.close() });
		},
    updatePayoutAccounts() {
      this.fetchPayoutAccountsList()
    },
    tabChanged(selectedTab) {
			// } else if ("Payout Accounts" === selectedTab.tab.name) {
			// 	this.fetchPayoutAccountsList()
    },
    tabClicked(selectedTab) {
      if ("Payin" === selectedTab.tab.name) {
        this.$refs.payinAccountsComponent.init()
      } else if ("Payout" === selectedTab.tab.name) {
				this.fetchPayoutAccountsList()
      }
    },
		loadingFullScreen(controller, txt, className) {
			this[controller] = this.$loading({
				lock: true,
				text: txt,
				spinner: className,
				background: 'rgba(0, 0, 0, 0.7)',
			})
		}
  },
}
</script>

<style lang="scss" scoped>
@import "./payoutAccounts.scss";
</style>
<style lang="scss">
.tabs-component.finance-parent-tabs > .tabs-component-tabs {
  .tabs-component-tab {
    box-shadow: none!important;
    @include theme-button-variant($white, theme-color("light"), $btn-border, $btn-box-shadow);
    background-color: #FFF!important;
    border: solid 1px #ddd!important;
    a {
      /* box-shadow: $btn-box-shadow; */
      box-shadow: none!important;
      font-family: inherit;
      letter-spacing: 3px;
      text-transform: uppercase;
      cursor: pointer;
      /* background-color: #1abc9c; */
      /* &:focus, &:active, &.focus {
        box-shadow: $btn-box-shadow;
      } */
    }
  }
  .tabs-component-tab.is-active {
    border: solid 1px #4ae387;
    a {
      box-shadow: none!important;
      @include theme-button-variant($white, theme-color("primary"), $btn-border, $btn-box-shadow);
      &.hover {
        background-color: lighten(theme-color("primary"), 10%) !important;
        color: $white;
      }
      &.focus {
        background-color: darken(theme-color("primary"), 15%);
        color: $white;
      }
    }
  }
}
</style>
